export function postData(url,body) {
    var responseService={}
	return(
        fetch(url,{
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Origin':'*'
            },
            body: JSON.stringify(body)   
          }).then(response => response.json())
		.then(data => {
			return(data);
		}).catch(function(error) {
            responseService='error'
            return(responseService);
        }));
}

export function getData(url) {
    var responseService={}
	return(
	fetch(url,{
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Origin':'*'
        }
    }).then(response => response.json()
    ).then(data => {
	    return(data);
	}).catch(function(error) {
        responseService='error'
        return(responseService);
    }));
}


// WEBPACK FOOTER //
// ./src/constants/Utils.js